import BaseView from './BaseView';
import EventCarousel from '../../modules/EventCarousel';
import ImageCarousel from '../../modules/ImageCarousel';
import VideoPlayer from '../../modules/VideoPlayer';

import { gsap } from 'gsap';
import InteractiveMap from "../../modules/InteractiveMap";

let view = null;

class Campus extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.container.querySelectorAll('[data-event-carousel]').forEach((el) => {
			this.modules.push(new EventCarousel(el));
		});

		this.container.querySelectorAll('[data-image-carousel]').forEach((el) => {
			this.modules.push(new ImageCarousel(el));
		});

		this.container.querySelectorAll('[data-video-player]').forEach((el) => {
			this.modules.push(new VideoPlayer(el));
		});

		this.quickNav = this.container.querySelector('[data-quicknav-bar]');
		this.quickNavLinks = this.container.querySelectorAll('[data-quicknav-bar-link]');
		this.quickNavLinks.forEach((link) => {
			link.addEventListener('click', (evt) => {
				evt.preventDefault();

				const targetID = link.getAttribute('data-target-section');
				this.scrollToSection(targetID, 2);
			});
		});

		const intersectionMargins = '-49% 0% -49% 0%';
		this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
			rootMargin: intersectionMargins,
		});

		this.navSections = this.container.querySelectorAll('[data-campus-section]');
		this.navSections.forEach((section) => {
			this.intersectionObserver.observe(section);
		});

		// Scroll to target Section when clicking Nav Menu (while alreay on campus)
        this.navLinks = document.querySelectorAll('[data-campus-nav-link]');
		this.boundHandleNavClick = this.handleNavClick.bind(this);
        this.navLinks.forEach(link => {
			link.addEventListener('click', this.boundHandleNavClick);
		});

		// Interactive map
		this.container.querySelectorAll('[data-interactive-map]').forEach((el) => {
			this.modules.push(new InteractiveMap(el));
		});

		// Lagen effect
		this.topSection = this.container.querySelector('[data-campus-top]');
		this.bottomSection = this.container.querySelector('[data-campus-bottom]');


		// Calculate the height op the top section on resize
		this.boundCalculateTopPartHeight = this.calculateTopPartHeight.bind(this);
		window.addEventListener('resize', this.boundCalculateTopPartHeight);
		this.calculateTopPartHeight();

		this.setupScrolling();

	}

	setupScrolling() {
		// Animate the top overlay during a part of the bottom section scroll duration
		gsap.to(this.topSection.querySelector('[data-campus-top-overlay]'), {
			opacity: 1,
			scrollTrigger: {
				trigger: this.bottomSection,
				start: () => {
					return `top-=${window.innerHeight - window.innerHeight * 1} bottom`;
				},
				end: () => {
					return `+=${window.innerHeight}`;
				},
				scrub: true,
			},
		});
	}

	calculateTopPartHeight() {
		// Set sticky position of top section as css variable
		this.topSection.style.setProperty(
			'--sticky-top',
			(this.topSection.clientHeight - document.documentElement.clientHeight) * -1 + 'px'
		);
	}


	handleIntersection(entries) {
		entries.forEach((entry) => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;

			// Section is in viewport
			if (ratio > 0) {
				const targetID = target.getAttribute('data-campus-section');
				this.setActiveLink(targetID);
			}
		});
	}

	setActiveLink(targetID) {
		const activeLink = this.quickNav.querySelector('[data-target-section="' + targetID + '"');
		if (activeLink) {
			this.quickNavLinks.forEach((link) => {
				link.classList.remove('is-active');
			});
			activeLink.classList.add('is-active');
		}
	}

	scrollToSection(targetID, duration = 0) {
		const targetSection = this.container.querySelector(targetID);

		gsap.to(window, {
			duration: duration,
			ease: 'power2.inOut',
			scrollTo: {
				y: targetSection
			},
		});
	}

	destroy() {
		super.destroy();

		this.intersectionObserver.disconnect();

		this.navLinks.forEach(link => {
			link.removeEventListener('click', this.boundHandleNavClick);
		});
	}
}

export default {
	namespace: 'template-campus',
	beforeEnter: ({ current, next, trigger, four }) => {
		view = new Campus(next.container);
		view.init();
	},
	afterEnter: ({ current, next, trigger, four }) => {
        view.afterEnterFunctions();
    },
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
